/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import { isBefore } from 'date-fns'
import 'react-day-picker/dist/style.css';
import enUs from 'date-fns/locale/en-US';

function DateRangePicker(props) {
  const [range, setRange] = useState({
    from: null,
    to: null,
    enteredTo: null,
  });

  useEffect(() => {
    if (props.initialRange) {
      setRange({
        ...props.initialRange,
        enteredTo: props.initialRange?.to,
      });
    }
  }, []);

  const isSelectingFirstDay = (from, to, day) => {
    const isBeforeFirstDay = from && isBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  };

  const handleDayClick = (day) => {
    const { from, to } = range;

    if (from && to && day >= from && day <= to) {
      const newRange = {
        from: null,
        to: null,
        enteredTo: null,
      };
      setRange(newRange);
      props.onChange(newRange);
      return;
    }

    if (isSelectingFirstDay(from, to, day)) {
      const newRange = {
        from: day,
        to: null,
        enteredTo: null,
      };

      setRange(newRange);
      props.onChange(newRange);
    } else {
      const newRange = {
        from: range.from,
        to: day,
        enteredTo: day,
      };
      setRange(newRange);
      props.onChange(newRange);
    }
  };

  const handleDayMouseEnter = (day) => {
    const { from, to } = range;
    if (!isSelectingFirstDay(from, to, day)) {
      setRange({
        from: range.from,
        to: range.to,
        enteredTo: day,
      });
    }
  };

  const { from, enteredTo } = range;
  const modifiers = { start: from, end: enteredTo };
  const disabledDays = { before: range.from };
  const selectedDays = [from, { from, to: enteredTo }];

  return (
    <div>
      <DayPicker
        mode="range"
        locale={enUs}
        selected={range}
        numberOfMonths={2}
        //fromMonth={from}
        selectedDays={selectedDays}
        //disabledDays={disabledDays}
        modifiers={modifiers}
        onDayClick={handleDayClick}
        onDayMouseEnter={handleDayMouseEnter}
      />
    </div>
  );
}

export default DateRangePicker;
